import React, {useContext, useEffect, useState} from 'react';
import TourListItem from "../components/Tour-list-item/Tour-list-item";
import {axios} from "../axios";
import {LangContext} from "../App";
import Seo from "../components/Seo/Seo";


const Tours = () => {
    const [data,setData] = useState([])
    const lang = useContext(LangContext)
    useEffect(()=>{
        axios.get(`${lang}/private-tour`)
            .then( res => setData(res.data.tours || []))
            .catch(err => {
                console.error('Error fetching tours:', err);
                setData([]);
            });
    },[lang])
    return (
        <div className='tours'>
            <Seo pageKey="privateTours" />
            <div className="center-wrapper">
                <div className="tours-grid">
                    {data?.map(e => <TourListItem tour={e} path='private-tour'/>)}
                </div>
            </div>
        </div>
    );
};

export default Tours;